import { nodes as demo } from './demo';
import { nodes as v2x } from './v2x';
import {
  detectDemoMode,
  eventGenerator,
  sourceGenerator, widgetDataGenerator,
} from './helper';

const demoList = { demo, v2x };

export const getDemoData = () => demoList[detectDemoMode()];

export const makeDemoEventGenerator = () => {
  const demoData = demoList[detectDemoMode()];

  if (demoData && demoData.events) {
    return eventGenerator(demoData.events);
  }

  return null;
};

export const makeDemoSourceGenerator = () => {
  const demoData = demoList[detectDemoMode()];

  if (demoData && demoData.source) {
    return sourceGenerator(demoData.source);
  }

  return null;
};

export const makeDemoWidgetDataGenerator = () => {
  const demoData = demoList[detectDemoMode()];

  if (demoData && demoData.widgets) {
    return widgetDataGenerator(demoData.widgets);
  }

  return null;
};
